const LABexercise01 = () => {
  return (
    <div>
      <h1>LAB Exercise 01</h1>
      {/* Add your content here */}
    </div>
  );
};

export default LABexercise01;
